"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TOOL_NAME = exports.TOOL_ID = exports.DOC_CORE_ACTION = exports.DOC_CORE_MODULE = exports.TOOL_FILE_TYPE = exports.DOC_CORE_OPERNAME = void 0;
exports.DOC_CORE_OPERNAME = 'doc_core';
exports.TOOL_FILE_TYPE = 15;
exports.DOC_CORE_MODULE = {
    visit: 'visit',
    edit: 'edit',
};
exports.DOC_CORE_ACTION = {
    detailPage: 'detail_page',
    editText: 'edit_text',
};
exports.TOOL_ID = {
    resumeAssistant: 'resume_assistant',
    resumeBeautification: 'resume_beautification',
};
exports.TOOL_NAME = {
    resumeAssistant: '简历助手',
    resumeBeautification: '简历美化',
};
//# sourceMappingURL=doc-core.js.map